export function relativeTime(date) {
  if (!date) return null;
  const seconds = Math.floor((Date.now() - new Date(date)) / 1000);
  if (seconds < 60) return "Completed just now";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `Completed ${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `Completed ${hours} hour${hours !== 1 ? 's' : ''} ago`;
  const days = Math.floor(hours / 24);
  return `Completed ${days} day${days !== 1 ? 's' : ''} ago`;
}
